module.exports = "/_next/static/images/ape-50d959309b2e69e0180620107b43d331.svg";